/**
 * Megamenu functionality
 * Handles desktop hover and mobile accordion behavior
 */
(function($) {
  'use strict';

  var DESKTOP_BREAKPOINT = 992;
  var HOVER_DELAY = 200;
  var megamenuLeaveTimer;

  function isDesktop() {
    return $(window).width() >= DESKTOP_BREAKPOINT;
  }

  /**
   * Keep Case Studies highlighted in the Build menu for this theme.
   */
  function setActiveMenuItem() {
    $('.header-megamenu__category[data-category="case-studies"]').addClass('active');
    $('.header-megamenu__panel[data-panel="case-studies"]').addClass('active');
  }

  /**
   * Close all megamenus and reset states
   */
  function closeAllMegamenus() {
    $('.header-navigation-item.has-megamenu').removeClass('is-open');
    $('.header-megamenu.js-megamenu').removeClass('is-open');
    $('.header-megamenu__category').removeClass('active');
    $('.header-megamenu__panel').removeClass('active');
    setActiveMenuItem();
  }

  /**
   * Mobile: click trigger toggles accordion
   */
  function initMobileAccordion() {
    $(document).on('click', '.js-megamenu-link', function(e) {
      if (isDesktop()) return;

      e.preventDefault();
      e.stopPropagation();
      var $item = $(this).closest('.header-navigation-item.has-megamenu');
      $item.toggleClass('is-open');
    });
  }

  /**
   * Desktop: show megamenu on hover with delay
   */
  function initDesktopHover() {
    // Navigation item hover
    $(document).on('mouseenter', '.header-navigation-item.has-megamenu', function() {
      if (!isDesktop()) return;

      clearTimeout(megamenuLeaveTimer);
      var menuType = $(this).data('menu');

      // Close all other megamenus
      $('.header-navigation-item.has-megamenu').not(this).removeClass('is-open');
      $('.header-megamenu.js-megamenu').removeClass('is-open');
      $(this).addClass('is-open');

      // Open corresponding desktop megamenu
      $('.header-megamenu.js-megamenu[data-menu="' + menuType + '"].header-megamenu--desktop').addClass('is-open');
    });

    $(document).on('mouseleave', '.header-navigation-item.has-megamenu', function() {
      if (!isDesktop()) return;

      var $item = $(this);
      var menuType = $(this).data('menu');

      megamenuLeaveTimer = setTimeout(function() {
        $item.removeClass('is-open');
        $('.header-megamenu.js-megamenu[data-menu="' + menuType + '"].header-megamenu--desktop').removeClass('is-open');
      }, HOVER_DELAY);
    });

    // Megamenu panel hover (keeps menu open when moving to dropdown)
    $(document).on('mouseenter', '.header-megamenu.js-megamenu', function() {
      if (!isDesktop()) return;

      clearTimeout(megamenuLeaveTimer);
      var menuType = $(this).data('menu');
      $('.header-navigation-item.has-megamenu[data-menu="' + menuType + '"]').addClass('is-open');
      $(this).addClass('is-open');
    });

    $(document).on('mouseleave', '.header-megamenu.js-megamenu', function() {
      if (!isDesktop()) return;

      var menuType = $(this).data('menu');
      var $megamenu = $(this);

      megamenuLeaveTimer = setTimeout(function() {
        $('.header-navigation-item.has-megamenu[data-menu="' + menuType + '"]').removeClass('is-open');
        $megamenu.removeClass('is-open');
        // Reset active states and restore URL-based highlight
        $megamenu.find('.header-megamenu__category').removeClass('active');
        $megamenu.find('.header-megamenu__panel').removeClass('active');
        setActiveMenuItem();
      }, HOVER_DELAY);
    });
  }

  /**
   * Desktop: hover category switches active panel
   */
  function initCategoryHover() {
    $(document).on('mouseenter', '.header-megamenu__category.js-megamenu-category', function() {
      if (!isDesktop()) return;

      var cat = $(this).data('category');
      if (!cat) return;

      var $megamenu = $(this).closest('.js-megamenu');
      $megamenu.find('.header-megamenu__category').removeClass('active');
      $(this).addClass('active');
      $megamenu.find('.header-megamenu__panel').removeClass('active');

      var $panel = $megamenu.find('.header-megamenu__panel[data-panel="' + cat + '"]');
      if ($panel.length) {
        $panel.addClass('active');
      }
    });
  }

  /**
   * Close megamenu on link click
   */
  function initLinkClose() {
    $(document).on('click', '.header-megamenu a', function() {
      // Don't close if it's just a category link on desktop
      if (isDesktop() && $(this).hasClass('header-megamenu__category')) {
        return;
      }
      closeAllMegamenus();
    });
  }

  /**
   * Close megamenu on click outside (desktop only)
   */
  function initOutsideClose() {
    $(document).on('click', function(e) {
      if (!isDesktop()) return;

      var $target = $(e.target);
      var isInsideNav = $target.closest('.header-navigation-item.has-megamenu').length;
      var isInsideMegamenu = $target.closest('.header-megamenu.js-megamenu').length;

      if (!isInsideNav && !isInsideMegamenu) {
        closeAllMegamenus();
      }
    });
  }

  /**
   * Mobile menu toggle (burger)
   * Note: open/close is handled by main.js — here we only reset megamenu state on close
   */
  function initMobileMenu() {
    $(document).on('click', '.js-close-mob-menu', function() {
      closeAllMegamenus();
    });
  }

  /**
   * Mobile: Products category dropdown toggle
   */
  function initMobileDropdown() {
    $(document).on('click', '.js-mobile-dropdown-trigger', function(e) {
      if (isDesktop()) return;

      e.preventDefault();
      e.stopPropagation();
      var $trigger = $(this);
      var $dropdown = $trigger.find('.js-mobile-dropdown');

      $trigger.toggleClass('active');
      if ($trigger.hasClass('active')) {
        $dropdown.slideDown(200);
      } else {
        $dropdown.slideUp(200);
      }
    });
  }

  /**
   * Initialize megamenu
   */
  function init() {
    setActiveMenuItem();
    initMobileMenu();
    initMobileAccordion();
    initMobileDropdown();
    initDesktopHover();
    initCategoryHover();
    initLinkClose();
    initOutsideClose();
  }

  // Initialize on document ready
  $(document).ready(init);

})(jQuery);
